/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_LoadingInputs */

const cs_addr_sugg_loading = /** @type {(inputs: Addr_Sugg_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledám v RÚIAN…`)
};

const en_addr_sugg_loading = /** @type {(inputs: Addr_Sugg_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching RÚIAN…`)
};

/**
* | output |
* | --- |
* | "Searching RÚIAN…" |
*
* @param {Addr_Sugg_LoadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_loading = /** @type {((inputs?: Addr_Sugg_LoadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_LoadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_loading(inputs)
	return cs_addr_sugg_loading(inputs)
});